/**
 * DEPRECATED-delete-step-comment-request.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { ReplyVerifyingMessage } from "../general/reply-message";
import { MessageTag } from "../message-tag";

export class DeprecatedDeleteStepCommentRequest extends ReplyVerifyingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.DEP_REQ_DELETE_STEP_COMMENT;
	public static tag : MessageTag = MessageTag.DEP_REQ_DELETE_STEP_COMMENT;

  /**
   * Construct a new {@link DeleteStepCommentRequest}.
   */
  constructor (
    public commentId : number,
    public stepId : number
  )
  {
    super();
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/collaboration/DEPRECATED-delete-step-comment-request.ts